export default __webpack_public_path__ + "static/media/christmas6.9877b469.png";